import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button  from 'react-bootstrap/Button'


const Contact = () => {
  return (
    <div>
      <Container>
        <Row className='d-flex justify-content-center mt-5'>
          <Col className='shadow p-3 mb-5 bg-body-tertiary rounded' md={4}>
           <h4 className='text-center mb-4'>Contact With Us</h4>
            <Form>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" placeholder="Enter Name" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="name@example.com" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control type="number" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                <Form.Label>Example textarea</Form.Label>
                <Form.Control as="textarea" rows={3} />
              </Form.Group>
            </Form>
            <Button variant='danger'>Submit</Button>
          </Col>
        </Row>
      </Container>
      <Container className='mt-5'>
        <h3 className='text-center mb-5'>Our Details</h3>
        <Row className='d-flex justify-content-evenly'>
          <Col md={4} className='shadow-lg p-3 mb-5 bg-body-tertiary rounded'>
            <div className="text-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
              </svg>
            </div>
            <h5 className='text-center mt-2'>9532348115</h5>
            <h5 className='text-center'>9452731916</h5>
          </Col>
          <Col md={4} className='shadow-lg p-3 mb-5 bg-body-tertiary rounded'>
            <div className="text-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
              </svg>
            </div>
            <h5 className='text-center mt-3'>prinkamis.gzp@gmail.com</h5>
          </Col>
        </Row>
        <Row className='d-flex justify-content-evenly'>
          <Col md={4} className='shadow-lg p-3 mb-5 bg-body-tertiary rounded'>
            <div className="text-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
              </svg>
            </div>
            <h5 className='text-center mt-2'>Hansrajpur (Yusufpur), Ghazipur (U.P)</h5>
          </Col>
          <Col md={4} className='shadow-lg p-3 mb-5 bg-body-tertiary rounded'>
            <div className="text-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-radar" viewBox="0 0 16 16">
                <path d="M6.634 1.135A7 7 0 0 1 15 8a.5.5 0 0 1-1 0 6 6 0 1 0-6.5 5.98v-1.005A5 5 0 1 1 13 8a.5.5 0 0 1-1 0 4 4 0 1 0-4.5 3.969v-1.011A2.999 2.999 0 1 1 11 8a.5.5 0 0 1-1 0 2 2 0 1 0-2.5 1.936v-1.07a1 1 0 1 1 1 0V15.5a.5.5 0 0 1-1 0v-.518a7 7 0 0 1-.866-13.847" />
              </svg>
            </div>
            <h5 className='text-center'>Drop Locations Covers Maximum Circular Area</h5>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row className='mb-5'>
          <h5 className='text-center mt-5 mb-5'>Reach Us Through Google Map</h5>
          <Col className='d-flex justify-content-center' >
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3596.0195960154315!2d83.45338272163826!3d25.670645120647915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3991faf07cfed3d9%3A0xe975adfe6e12d65e!2sPriyanka%20Memorial%20International%20School%2CYusufpur%20Kharba%20Gzp.!5e0!3m2!1sen!2sin!4v1741322284734!5m2!1sen!2sin" title='Location' width="900" height="450" style={{ border: '0', borderRadius: '15px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Contact